import { render, staticRenderFns } from "./index.vue?vue&type=template&id=587941b3"
import script from "./editAddress.js?vue&type=script&lang=js&external"
export * from "./editAddress.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports